<template>
  <ModalBase show-modal auto-h on-top @close-modal="close" :overlay-scrollb="false" class="finance-invoice-modal">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
            {{ $gettext('FINANCE') }}
        </template>
        <template v-slot:title>
          {{ $gettext('Invoice') }}
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <div v-if="!loading" class="finance-widget-wrap">
        <invoice-finance />
      </div>
    </template>
    <template v-slot:actions v-if="currentUserProfile.show_rabo_notification ">
      <div class="finance-modal-actions">
        <GekkoButton
          :href="Urls['accounts_notification_settings']()"
          :text="$gettext('Don\'t show again')"
          variant="link"
          size="sm"
        />
      </div>
    </template>
  </ModalBase>
</template>
  
<script>
import { mapGetters } from "vuex";

import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

import { initRaboWidget, subscribeToEvent  } from '@embedded-banking-fundr/rabobank-invoice-finance'

export default {
  name: "InvoiceFinanceModal",
  components: {
    ModalBase,
    TitleBar,
    GekkoButton,
    LoadingSpinner,
  },
  props: {
    invoice: {
      type: Object,
      default: () => {}
    },
    invoicePdf: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: true,
      eventSubscriptionConfig: [
        { event: 'started', callback: 'onStarted' },
        { event: 'abandon', callback: 'onAbandon' },
        { event: 'concluded', callback: 'onConcluded' },
        { event: 'exit', callback: 'onExit' }
      ],
      widgetSubscriptionEvents: [],
      widgetApiKey: 'kM4befCQapljQYQEOQERwnvdDfHo8Y' // uat
    }
  },
  computed: {
    ...mapGetters({ 
      currentUserProfile: 'main/getCurrentUserProfile',
      currentCompany: "main/getCurrentCompany"
    })
  },
  created () {
    this.setupData()
  },
  mounted () {
    document.body.classList.add('modal-on')

    this.eventSubscriptionConfig.forEach(subscription => {
      this.widgetSubscriptionEvents.push(subscribeToEvent(subscription.event, (data) => { this[subscription.callback](data) }))
    })
  },
  beforeDestroy () {
    this.widgetSubscriptionEvents.forEach(subscription => {
      subscription.unsubscribe()
    })
  },
  methods: {
    close () {
      this.$emit('close')
      document.body.classList.remove('modal-on')
    },
    setupData () {
      this.loading = true
      const widgetContactDetails = {
        name: this.currentCompany.created_by.first_name,
        surname: this.currentCompany.created_by.last_name,
        phone: this.currentCompany.phone_number,
        email: this.currentCompany.created_by.email
      }
      const widgetInvoices = []
      widgetInvoices.push({
        invoiceId: this.invoice.number,
        invoiceAmount: parseFloat(this.invoice.total_amount),
        issuerDate: this.invoice.invoice_date,
        deadlineDate: this.invoice.due_date,
        debtorKvk: this.invoice.recipient_kvk,
        debtorName: this.invoice.recipient_name,
        debtorType: ((this.invoice.recipient) ? 'B2B' : 'B2C')
      })
      const widgetDocuments = {
        filename: 'pdf.pdf',
        dataUrl: this.invoicePdf
      }

      // mode: 'sandbox' | 'production',
      const widgetConfig = {
        apiKey: this.widgetApiKey,
        mode: 'sandbox',
        partnerId: 'GEKKO',
        kvkNumber: this.currentCompany.kvk,
        contactDetails: widgetContactDetails,
        invoices: widgetInvoices,
        invoiceDocuments: widgetDocuments
      }
      this.loading = false

      initRaboWidget(widgetConfig)
    },
    onStarted (data) {
      console.log('Invoice finance process started', data);
    },
    onAbandon (data) {
      console.log('Invoice finance process abandon', data);
    },
    onConcluded (data) {
      console.log('Invoice finance process concluded', data);
    },
    onExit (data) {
      console.log('Invoice finance process exit', data);
      this.close()
    }
  }
};
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
invoice-finance {
  --rabobank-color-primary: #22AC8A;
  --rabobank-color-secondary: #37A0CD;
  --rabobank-svg-primary: #22AC8A;
  --rabobank-svg-primary-light: #CEF5EB;
  --rabobank-svg-secondary: #37A0CD;
}
.finance-invoice-modal {
  font-size: 1rem;
  .gk-modal {
    max-width: 600px;
    .modal-content-wrap { 
      position: relative; 
      margin: -1rem;
      margin-bottom: 0;
      .finance-widget-wrap {
        padding: 0;
      }
    }
    .finance-modal-actions {
      display: flex;
      justify-content: center;
      border-top: 1px solid $colorBorderDash;
      padding-top: 1rem;
    }
  }
}
</style>